export default __webpack_public_path__ + "698311ecf0ae0f2ee280cbe67e053f28.png";